'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Breadcrumb = require('./Breadcrumb.scss');

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breadcrumb = (_temp2 = _class = function (_PureComponent) {
    (0, _inherits3.default)(Breadcrumb, _PureComponent);

    function Breadcrumb() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Breadcrumb);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Breadcrumb.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumb)).call.apply(_ref, [this].concat(args))), _this), _this.ensureTrailingSlash = function (target) {
            return target.endsWith('/') ? target : target + '/';
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Breadcrumb, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                last = _props.last,
                target = _props.target,
                type = _props.type;

            var classes = label.length > 32 ? _Breadcrumb2.default.breadcrumb + ' ' + _Breadcrumb2.default.ellipsis : '' + _Breadcrumb2.default.breadcrumb;
            return (0, _jsx3.default)('li', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _Breadcrumb2.default.wrapper
            }, void 0, type === 'anchor' && (0, _jsx3.default)(_components.Link, {
                href: this.ensureTrailingSlash(target),
                primaryWeak: true
            }, void 0, label), type === 'label' && (0, _jsx3.default)('div', {
                className: 'pull-left'
            }, void 0, label), type === 'link' && (0, _jsx3.default)(_components.Link, {
                route: true,
                to: this.ensureTrailingSlash(target),
                primaryWeak: true
            }, void 0, label), !last && (0, _jsx3.default)('span', {
                className: _Breadcrumb2.default.chevron
            }, void 0, '\u203A')));
        }
    }]);
    return Breadcrumb;
}(_react.PureComponent), _class.defaultProps = {
    label: '',
    last: false,
    target: '',
    type: 'label'
}, _temp2);
exports.default = Breadcrumb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumb/Breadcrumb.js
// module id = M8WM
// module chunks = 46